import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "./renderer.less";
// 段落
const Paragraph = {
  name: "HtmlParagraph",
  props: {
    node: {
      type: Object,
      default: () => ({})
    }
  },
  render() {
    const { $slots, node } = this;
    const { indent, textAlign, lineHeight } = node;
    return <p style={{ textAlign: textAlign, textIndent: indent, lineHeight: lineHeight }}>{$slots.default}</p>;
  }
};
// 文本
const Text = {
  name: "HtmlText",
  render() {
    const { $slots } = this;
    return <span>{$slots.default}</span>;
  }
};
// 图片
const Img = {
  name: "HtmlImg",
  porps: {
    src: {
      type: String,
      default: ""
    },
    alt: {
      type: String,
      default: ""
    }
  },
  render() {
    const { src, alt } = this;
    return <img class="w-editor-image" src={src} alt={alt} />;
  }
};
// 超链接
const Link = {
  name: "HtmlLink",
  props: {
    href: {
      type: String,
      default: ""
    },
    target: {
      type: String,
      default: ""
    },
    rel: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    }
  },
  render() {
    const { href, target, rel, title, $slots } = this;
    return (
      <a href={href} target={target} rel={rel} title={title}>
        {$slots.default}
      </a>
    );
  }
};
// 无序列表 | 有序列表
const List = {
  name: "HtmlList",
  props: {
    type: {
      type: String,
      default: ""
    }
  },
  render() {
    const { type, $slots } = this;
    let vnode = null;
    if (type === "numbered-list") {
      vnode = <ol>{$slots.default}</ol>;
    }
    if (type === "bulleted-list") {
      vnode = <ul>{$slots.default}</ul>;
    }
    if (type === "list-item") {
      vnode = <li>{$slots.default}</li>;
    }
    return vnode;
  }
};
// 标题
const Header = {
  name: "HtmlList",
  props: {
    type: {
      type: String,
      default: ""
    }
  },
  render() {
    const { type, $slots } = this;
    let vnode = null;
    if (type === "header1") {
      vnode = <h1>{$slots.default}</h1>;
    } else if (type === "header2") {
      vnode = <h2>{$slots.default}</h2>;
    } else if (type === "header3") {
      vnode = <h3>{$slots.default}</h3>;
    } else if (type === "header4") {
      vnode = <h4>{$slots.default}</h4>;
    } else if (type === "header5") {
      vnode = <h5>{$slots.default}</h5>;
    }
    return vnode;
  }
};
// 表格
const Table = {
  name: "HtmlTable",
  props: {
    type: {
      type: String,
      default: ""
    },
    node: {
      type: Object,
      default: () => ({})
    }
  },
  render() {
    const { type, node, $slots } = this;

    let vnode = null;
    if (type === "table") {
      const columns = node.children[0].children || [];
      vnode = (
        <table class="w-editor-table">
          <colgroup>
            {columns.map(col => {
              const { width = "100px" } = col;
              return <col width={width}></col>;
            })}
          </colgroup>
          <tbody>{$slots.default}</tbody>
        </table>
      );
    } else if (type === "table-row") {
      const { height } = node;
      vnode = <tr style={{ height: height || 32 }}>{$slots.default}</tr>;
    } else if (type === "table-cell") {
      const { colSpan, rowSpan, bgColor } = node;
      const isCollapsed = colSpan === 0 || rowSpan === 0;
      vnode = (
        <td
          colSpan={colSpan}
          rowSpan={rowSpan}
          style={{ display: isCollapsed ? "none" : undefined, backgroundColor: bgColor }}
        >
          {$slots.default}
        </td>
      );
    }
    return vnode;
  }
};
// 分割线
const Divider = {
  name: "HtmlDivider",
  props: {
    type: {
      type: String,
      default: ""
    },
    node: {
      type: Object,
      default: () => ({})
    }
  },
  render() {
    const { type, node, $slots } = this;
    const { value } = node;

    let vnode = null;
    if (type === "divider") {
      vnode = <div class={`w-editor-divider ${value}`}>{$slots.default}</div>;
    }

    return vnode;
  }
};

// 页签
const Tabs = {
  name: "HtmlTabs",
  props: {
    type: {
      type: String,
      default: ""
    },
    node: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      active: 0
    };
  },
  render() {
    const { type, node, $slots } = this;

    let vnode = null;
    if (type === "tabs") {
      const { children = [] } = node;
      vnode = (
        <div class={`w-editor-tabs`}>
          <div class="w-editor-tabs-header" contentEditable={false}>
            <div class="w-editor-tabs-nav">
              {children.map((item, index) => {
                return (
                  <div
                    key={item.key}
                    class={`w-editor-tabs-nav-item ${this.active === index ? "active" : ""}`}
                    onClick={e => this.handleActive(e, index)}
                  >
                    {item.title}
                  </div>
                );
              })}
            </div>
          </div>
          <div class="w-editor-tabs-content">
            {$slots.default.map((child, index) => {
              return (
                <div class="w-editor-tabs-panel" style={{ display: this.active === index ? "block" : "none" }}>
                  {child}
                </div>
              );
            })}
          </div>
        </div>
      );
    } else if (type === "tab-item") {
      vnode = <div class={`w-editor-tab-item-container`}>{$slots.default}</div>;
    }
    return vnode;
  },
  methods: {
    handleActive(e, index) {
      this.active = index;
    }
  }
};
// 视频
const Video = {
  name: "HtmlVideo",
  props: {
    type: {
      type: String,
      default: ""
    },
    node: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      iframeHtml: ""
    };
  },
  mounted() {
    const { node } = this;
    const { src, width, height } = node;
    if (src.trim().indexOf("<iframe ") === 0) {
      this.iframeHtml = this.setSizeStyleToIframeHtml(src, width, height);
    }
  },
  render() {
    const { type, node, $slots } = this;

    let vnode = null;
    if (type === "video") {
      const { src, poster, width, height } = node;
      if (src.trim().indexOf("<iframe ") === 0) {
        // iframe 形式，第三方视频
        vnode = (
          <div class={`w-editor-video`}>
            {/* 内嵌第三方 iframe 视频 */}
            <span contentEditable="false" domPropsInnerHTML={this.iframeHtml}></span>
            {$slots.default}
          </div>
        );
      } else {
        // 其他，mp4 格式
        const videoVnode = (
          <video
            poster={poster}
            controls
            width={width !== "auto" ? width : undefined}
            height={height !== "auto" ? height : undefined}
          >
            <source src={src} type="video/mp4" />
            {`Sorry, your browser doesn't support embedded videos.\n 抱歉，浏览器不支持 video 视频`}
          </video>
        );

        vnode = (
          <div class={`w-editor-video`}>
            {videoVnode}
            {$slots.default}
          </div>
        );
      }
    }
    return vnode;
  },
  methods: {
    setSizeStyleToIframeHtml(src, width, height) {
      const $div = document.createElement("div");
      $div.innerHTML = src;
      const $iframe = $div.getElementsByTagName("iframe")[0];
      $iframe.setAttribute("width", width);
      $iframe.setAttribute("height", height);

      return $iframe.outerHTML;
    }
  }
};

// 音频
const Audio = {
  name: "HtmlAudio",
  props: {
    type: {
      type: String,
      default: ""
    },
    node: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isPlaying: 0
    };
  },
  render() {
    const { type, node, $slots } = this;

    let vnode = null;
    if (type === "audio") {
      const { src } = node;
      vnode = (
        <div class="w-editor-audio">
          <div class="audio-player">
            <audio
              ref="audioRef"
              src={src}
              onTimeUpdate={this.handleTimeUpdate}
              onLoadedMetadata={this.handleLoadedMetadata}
              onEnded={this.handleEnded}
            />
            <div class="controls">
              <button class="play-button" onClick={e => this.togglePlay(e)}>
                {this.isPlaying ? (
                  <i class="icon">
                    <svg viewBox="0 0 1024 1024">
                      <path d="M289.7 962c-65.6 0-118.8-53.2-118.8-118.8V180.8c0-65.6 53.2-118.8 118.8-118.8s118.8 53.2 118.8 118.8v662.4c0 65.6-53.2 118.8-118.8 118.8zM734.3 962c-65.6 0-118.8-53.2-118.8-118.8V180.8c0-65.6 53.2-118.8 118.8-118.8s118.8 53.2 118.8 118.8v662.4c0 65.6-53.2 118.8-118.8 118.8z"></path>
                    </svg>
                  </i>
                ) : (
                  <i class="icon">
                    <svg viewBox="0 0 1024 1024" style={{ marginLeft: 4 }}>
                      <path d="M833.308444 599.096889l-558.478222 380.017778c-45.738667 31.118222-106.837333 17.351111-136.476444-30.776889a107.690667 107.690667 0 0 1-15.815111-56.32V131.982222C122.538667 74.752 166.741333 28.273778 221.240889 28.273778c19.000889 0 37.603556 5.802667 53.589333 16.668444l558.478222 379.960889c45.738667 31.118222 58.823111 95.345778 29.240889 143.473778-7.566222 12.288-17.578667 22.755556-29.240889 30.72z"></path>
                    </svg>
                  </i>
                )}
              </button>
              {/* <div class="time">
          {formatTime(currentTime)} / {formatTime(duration)}
        </div> */}
            </div>
          </div>
          {$slots.default}
        </div>
      );
    }
    return vnode;
  },
  methods: {
    togglePlay(e) {
      e.preventDefault();
      e.stopPropagation();
      if (this.$refs.audioRef) {
        const $audio = this.$refs.audioRef;
        if (this.isPlaying) {
          $audio.pause();
        } else {
          $audio.play();
        }
        this.isPlaying = !this.isPlaying;
      }
    },
    handleEnded() {
      this.isPlaying = false;
    },

    handleTimeUpdate() {
      if (this.$refs.audioRef) {
        // const $audio = this.$refs.audioRef;
      }
    },

    handleLoadedMetadata() {
      if (this.$refs.audioRef) {
        // const $audio = this.$refs.audioRef;
      }
    }
  }
};

// 折叠模块
const Flod = {
  name: "HtmlFlod",
  props: {
    type: {
      type: String,
      default: ""
    },
    node: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isExpanded: false
    };
  },
  render() {
    const { type, node, $slots } = this;

    let vnode = null;
    if (type === "flod") {
      const { title } = node;
      vnode = (
        <div class="w-editor-flod">
          <div class="flod-box">
            <div class="flod-title" contentEditable={false}>
              <div
                class="expand-collapse-btn"
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.isExpanded = !this.isExpanded;
                }}
              >
                {this.isExpanded ? (
                  <svg viewBox="0 0 1024 1024">
                    <path d="M64 576h896V448H64z"></path>
                  </svg>
                ) : (
                  <svg viewBox="0 0 1024 1024">
                    <path d="M576 64H448v384H64v128h384v384h128V576h384V448H576z"></path>
                  </svg>
                )}
              </div>
              <span>{title}</span>
            </div>
            <div class={`flod-content${this.isExpanded ? " expanded" : " collapsed"}`}>{$slots.default}</div>
          </div>
        </div>
      );
    }
    return vnode;
  },
  methods: {}
};

// 注释内容
const PopoverComment = {
  name: "HtmlPopoverComment",
  props: {
    type: {
      type: String,
      default: ""
    },
    node: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {};
  },
  render() {
    const { type, node, $slots } = this;

    let vnode = null;
    if (type === "popover-comment") {
      const { data } = node;
      vnode = (
        <el-popover placement="bottom" trigger="hover">
          <div>
            <WikiEditorRenderer editorData={data}></WikiEditorRenderer>
          </div>
          <span slot="reference" style={{ cursor: "pointer", color: "#5db3e6" }}>
            {$slots.default}
          </span>
        </el-popover>
      );
    }

    return vnode;
  }
};

// 图片集
const ImageAlbum = {
  name: "HtmlImageAlbum",
  components: {
    Swiper,
    SwiperSlide
  },
  props: {
    type: {
      type: String,
      default: ""
    },
    node: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      swiperOptions: {
        initialSlide: 0,
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
        // pagination: {
        //   el: ".img-view-pagination",
        //   type: "fraction"
        // }
      },
      swiperOptionThumbs: {
        initialSlide: 0,
        spaceBetween: 10,
        slidesPerView: 5,
        // freeMode: true,
        // watchSlidesVisibility: true,
        // watchSlidesProgress: true,
        slideToClickedSlide: true,
        centeredSlides: true,
        navigation: {
          nextEl: ".swiper-thumbs-next",
          prevEl: ".swiper-thumbs-prev"
        }
      }
    };
  },
  mounted() {
    this.$nextTick(() => {
      const swiperTop = this.$refs.swiperTop.$swiper;
      const swiperThumbs = this.$refs.swiperThumbs.$swiper;
      // swiperThumbs.thumbs.swiper = swiperTop
      swiperTop.controller.control = swiperThumbs;
      swiperThumbs.controller.control = swiperTop;
    });
  },
  render() {
    const { type, node, $slots } = this;

    let vnode = null;
    if (type === "image-album") {
      const { data = [] } = node;
      vnode = (
        <div class={`w-editor-image-album`}>
          <div class="image-album-box">
            <Swiper class="swiper" ref="swiperTop" autoDestroy={true} autoUpdate={true} options={this.swiperOptions}>
              {data.map((src, index) => {
                return (
                  <SwiperSlide class="swiper-slide" key={index} zoom={true}>
                    <img src={src} alt="" class="swiper-lazy preview-image" />
                  </SwiperSlide>
                );
              })}
            </Swiper>

            <div class="thumbs">
              <Swiper class="swiper-thumbs" ref="swiperThumbs" options={this.swiperOptionThumbs}>
                {data.map((src, index) => {
                  return (
                    <SwiperSlide class="swiper-slide" key={index} zoom={true}>
                      <img src={src} alt="" class="swiper-lazy preview-image" />
                    </SwiperSlide>
                  );
                })}
              </Swiper>
              {/* <div class="swiper-thumbs-prev "></div>
              <div class="swiper-thumbs-next"></div> */}
            </div>
          </div>

          {$slots.default}
        </div>
      );
    }

    return vnode;
  }
};

const WikiEditorRenderer = {
  name: "WikiEditorRenderer",
  components: {},
  props: {
    editorData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {},
  render() {
    // 渲染文本样式
    const renderStyleText = data => {
      let vnode = data.text || "\uFEFF";
      if (data.bold) {
        vnode = <strong>{vnode}</strong>;
      }
      if (data.italic) {
        vnode = <em>{vnode}</em>;
      }
      if (data.underline) {
        vnode = <u>{vnode}</u>;
      }
      if (data.through) {
        vnode = <s>{vnode}</s>;
      }
      return vnode;
    };

    const renderLeaf = item => {
      return (
        <Text
          style={{
            color: item.color,
            backgroundColor: item.bgColor,
            fontSize: item.fontSize
          }}
        >
          {renderStyleText(item)}
        </Text>
      );
    };

    const renderElement = (children = []) => {
      if (Array.isArray(children) && children.length == 0) {
        return null;
      }
      return children.map(item => {
        let vnode = null;
        if (item.type) {
          switch (item.type) {
            case "image-album":
              vnode = (
                <ImageAlbum type={item.type} node={item}>
                  {renderElement(item.children)}
                </ImageAlbum>
              );
              break;
            case "popover-comment":
              vnode = (
                <PopoverComment type={item.type} node={item}>
                  {renderElement(item.children)}
                </PopoverComment>
              );
              break;
            case "flod":
              vnode = (
                <Flod type={item.type} node={item}>
                  {renderElement(item.children)}
                </Flod>
              );
              break;
            case "audio":
              vnode = (
                <Audio type={item.type} node={item}>
                  {renderElement(item.children)}
                </Audio>
              );
              break;
            case "video":
              vnode = (
                <Video type={item.type} node={item}>
                  {renderElement(item.children)}
                </Video>
              );
              break;
            case "tabs":
            case "tab-item":
              vnode = (
                <Tabs type={item.type} node={item}>
                  {renderElement(item.children)}
                </Tabs>
              );
              break;
            case "divider":
              vnode = (
                <Divider type={item.type} node={item}>
                  {renderElement(item.children)}
                </Divider>
              );
              break;
            case "table":
            case "table-row":
            case "table-cell":
              vnode = (
                <Table type={item.type} node={item}>
                  {renderElement(item.children)}
                </Table>
              );
              break;
            case "header1":
            case "header2":
            case "header3":
            case "header4":
            case "header5":
              vnode = <Header type={item.type}>{renderElement(item.children)}</Header>;
              break;
            case "numbered-list":
            case "bulleted-list":
            case "list-item":
              vnode = <List type={item.type}>{renderElement(item.children)}</List>;
              break;
            case "image":
              vnode = <Img src={item.src} alt={item.alt} style={item.style} />;
              break;
            case "link":
              vnode = (
                <Link href={item.url} target={item.target || "_blank"} rel={item.rel} title={item.title}>
                  {renderElement(item.children)}
                </Link>
              );
              break;
            case "paragraph":
              vnode = <Paragraph node={item}>{renderElement(item.children)}</Paragraph>;
              break;
            default:
              vnode = null;
          }
        } else {
          vnode = renderLeaf(item);
        }

        return vnode;
      });
    };
    return <div class="wiki-editor-content">{renderElement(this.editorData || [])}</div>;
  }
};
export default WikiEditorRenderer;
